import { chicagoToday } from './scheduleWeek';

/**
 * Who may change the sub on a class, by its date in America/Chicago — mirrors the
 * servlet's late-subs rules (the servlet stays authoritative; this only decides
 * what the UI offers):
 *  - today or later: assign/clear like any future class;
 *  - past, within {@link RETRO_LIMIT_DAYS}: managers "record" (saved as already
 *    accepted, no push); requesters must ask a manager;
 *  - older: locked for everyone.
 */
export type SubAction = 'assign' | 'record' | 'askManager' | 'tooOld';

export const RETRO_LIMIT_DAYS = 31;

const dayNumber = (isoDate: string): number => {
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return Date.UTC(y, m - 1, d) / 86_400_000;
};

export const subActionFor = (eventDate: string, isAdmin: boolean, now: Date = new Date()): SubAction => {
  const today = chicagoToday(now);
  if (eventDate.slice(0, 10) >= today) {
    return 'assign';
  }
  if (dayNumber(today) - dayNumber(eventDate) > RETRO_LIMIT_DAYS) {
    return 'tooOld';
  }
  return isAdmin ? 'record' : 'askManager';
};

/**
 * True when a sub's accept stamp falls on a Chicago day after the class: a manager
 * recorded it retroactively rather than the sub accepting ahead of time. Same rule
 * as the web (`wasRecordedAfter` in iflipweb-next `features/timeoff/logic.ts`).
 */
export const wasRecordedAfter = (acceptedOn: string | null | undefined, eventDate: string): boolean => {
  if (!acceptedOn) {
    return false;
  }
  const at = new Date(acceptedOn);
  if (Number.isNaN(at.getTime())) {
    return false;
  }
  return chicagoToday(at) > eventDate.slice(0, 10);
};
